<template>
  <div v-loading="loading" element-loading-background="transparent">
    <div class="base-card-info a-auto">
      <div class="info-card-title">
        支付宝管理
      </div>

      <div class="pb-3">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label">
                平台支付宝账号编号
              </div>
              <div class="info-item-value">
                {{ state.externalAgreementNo }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[158px]">
                商户签约号
              </div>
              <div class="info-item-value">
                {{ state.agreementNo }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                商户登录账号
              </div>
              <div class="info-item-value">
                {{ state.aliLoginAccount }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pb-3">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                签约状态
              </div>
              <div class="info-item-value">
                <custom-tag
                  class="!justify-start"
                  :label="alipayCompanySignStatusLabel[state.signStatus]"
                  :type="alipayCompanySignStatusColor[state.signStatus]"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[158px]">
                支付宝唯一用户号
              </div>
              <div class="info-item-value">
                {{ state.alipayUserId }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                支付宝唯一签约号
              </div>
              <div class="info-item-value">
                {{ state.agreementNo }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pb-3">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                代扣协议签约时间
              </div>
              <div class="info-item-value">
                {{ state.signTime }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[158px]">
                分配给开发者的应用id
              </div>
              <div class="info-item-value">
                {{ state.appId }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label">
                分配给商户的应用id
              </div>
              <div class="info-item-value">
                {{ state.authAppId }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pb-3">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                代扣协议生效时间
              </div>
              <div class="info-item-value">
                {{ state.validTime }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[158px]">
                开通的资金记账本id
              </div>
              <div class="info-item-value">
                {{ state.accountBookId }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                外卡卡号
              </div>
              <div class="info-item-value">
                {{ state.cardNo }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pb-3">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                外卡户名
              </div>
              <div class="info-item-value">
                {{ state.bankAccName }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[158px]">
                外卡支行
              </div>
              <div class="info-item-value">
                {{ state.cardBranch }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                外卡开户行
              </div>
              <div class="info-item-value">
                {{ state.cardBank }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pb-3">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                外卡开户地址
              </div>
              <div class="info-item-value">
                {{ state.cardLocation }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[158px]">
                外卡联行号
              </div>
              <div class="info-item-value">
                {{ state.cardDeposit }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex items-start">
              <div class="info-item-label w-[142px]">
                外卡状态
              </div>
              <div class="info-item-value">
                {{ state.accountBookStatus === 'A' ? '正常' : '异常' }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-button class="mt-4" @click="closeAndBack">
      <svg-icon icon="icon-park-outline:return" />返回
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { SvgIcon, CustomTag } from '@vue3/components';
import { getCustomState, useTabsStore } from '@core/main';
import { PropType, ref } from 'vue';
import { alipayCompanySignStatusColor, alipayCompanySignStatusLabel, IAlipayCompanyListItem } from '@core/main/types/alipay';

defineOptions({ name: 'SettlementInfo' }); // 结算订单详情

const { closeAndBack } = useTabsStore();

const state = getCustomState<IAlipayCompanyListItem>();

console.log(state);

defineProps({
  term: {
    type: String as PropType<'agent' | 'saas'>,
    required: true,
  },
});

const loading = ref(false);
</script>

<style lang="scss" scoped>
.info-item-label {
  @apply text-[#8c8c8c] pr-4;
}

.info-item-value {
  @apply text-[var(--color-text-primary)] flex-1;
}
</style>
